import { Card, Row, Col, Tag } from "antd";

function CounterOfferSummary({ counterOffers = [] }) {
  const total = counterOffers.length;

  const pending = counterOffers.filter(
    (c) => !c.status || c.status === "PENDING"
  ).length;

  const accepted = counterOffers.filter(
    (c) => c.status === "ACCEPTED"
  ).length;

  const declined = counterOffers.filter(
    (c) => c.status === "DECLINED"
  ).length;

  const stillInterested = counterOffers.filter(
    (c) => c.isStillInterested === true
  ).length;

  const Stat = ({ label, value, color }) => (
    <Col xs={12} sm={6} md={6} lg={3}>
      <Card size="small" style={{ textAlign: "center" }}>
        <div style={{ fontSize: 20, fontWeight: 600 }}>{value}</div>
        <Tag color={color} style={{ marginTop: 6 }}>
          {label}
        </Tag>
      </Card>
    </Col>
  );

  return (
    <Card style={{ marginBottom: 16 }}>
      <Row gutter={[12, 12]}>
        <Stat label="Total Offers" value={total} color="blue" />
        <Stat label="Pending" value={pending} color="orange" />
        <Stat label="Accepted" value={accepted} color="green" />
        <Stat label="Declined" value={declined} color="red" />
        <Stat
          label="Still Interested"
          value={stillInterested}
          color="purple"
        />
      </Row>
    </Card>
  );
}

export default CounterOfferSummary;